require.register("app/restaurant/stat/OrderCountView", function(exports, require, module){
  $0
  
});

